import AService from '@/services/AService'

const ENTITY_NAME = 'barcodes';

export default class BarcodeService extends AService {
  /**
   * Récupère tous les codes barres
   * @param {BarcodeRangeFilter} filter Le filtre
   * @return {Promise<BarcodeRangeDto[]>} La liste des codes barres
   */
  async getAll(filter) {
    const response = await this.http.get(`${this.baseUrl}/${ENTITY_NAME}/`, {params: filter})
    return response.data;
  }

  /**
   * Créer une plage de code barre pour une ligne
   * @param {BarcodeRangeCreateForLineIdRequest} request La requête
   * @return {Promise<BarcodeRangeDto>} La plage de code barre créée
   */
  async createForLineId(request) {
    const response = await this.http.post(`${this.baseUrl}/${ENTITY_NAME}/create-for-line-id`, request)
    return response.data
  }

  /**
   * Créer une plage de code barre pour une ligne
   * @param {BarcodeRangeCreateRequest} request La requête
   * @return {Promise<BarcodeRangeDto>} La plage de code barre créée
   */
  async create(request) {
    const response = await this.http.post(`${this.baseUrl}/${ENTITY_NAME}`, request)
    return response.data
  }

  /**
   * Supprime une plage de code barre
   * @param {number} id L'identifiant de la plage de code barre
   * @return {Promise<null>}
   */
  async delete(id) {
    const response = await this.http.delete(`${this.baseUrl}/${ENTITY_NAME}/${id}`)
    return response.data
  }
}
